<ion-content
  class="modal-outher-container detail-group--overflow-auto custom-scrollbar"
>
  <div
    class="detail-group__cover-mobile"
    *ngIf="addUserModalOpen && p.renderMobile"
  ></div>
  <ion-grid
    class="modal-inner-container modal-inner-container--scroll position-relative custom-scrollbar"
  >
    <div
      class="detail-group__cover"
      *ngIf="addUserModalOpen && !p.renderMobile"
    ></div>
    <ion-row>
      <ion-col>
        <app-modal-header
          [header]="setHeader()"
          (close)="close()"
        ></app-modal-header>

        <form
          [formGroup]="form"
          (ngSubmit)="Save()"
          class="detail-group__form-container"
        >
          <app-input
            type="input"
            [form]="form"
            formControlName="name"
            label="NAME"
            [submittedError]="validationError"
          ></app-input>

          <app-input
            type="textarea"
            [form]="form"
            formControlName="description"
            label="DESCRIPTION"
            [autoGrow]="growAuto"
            (ionInput)="onInput()"
            [submittedError]="validationError"
          ></app-input>

          <ion-list>
            <ion-item
              *ngFor="let user of companyGroupServ.companyGroup.users"
              lines="none"
              class="detail-group__user"
            >
              <ion-label
                >{{ user.firstName }} {{ user.lastName }} ({{ user.email
                }})</ion-label
              >
              <ion-button
                (click)="onRemoveUser(user)"
                size="small"
                fill="clear"
                shape="round"
              >
                <ion-icon slot="icon-only" name="close"></ion-icon>
              </ion-button>
            </ion-item>
          </ion-list>

          <ion-item lines="none" class="input">
            <div class="control-display">
              <ion-button
                (click)="addUser()"
                expand="block"
                shape="round"
                size="default"
              >
                {{ "BOOKING.ADD_USER" | translate }}
                <ion-icon slot="end" name="add"></ion-icon>
              </ion-button>
            </div>
          </ion-item>

          <ion-item class="input" lines="none">
            <ion-button
              type="submit"
              class="button-margin-top-md"
              size="medium"
              slot="end"
              [disabled]="saving"
              >{{'SAVE' | translate }}</ion-button
            >
          </ion-item>
        </form>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
